<!-- Модалка создания нового ТА -->
<template>
    <TheModal class="sm" @close="close">
        <template v-slot:head>
            {{ $route.meta.title }} <a target="_blank" :href="getKBLink('vms_new')" class="btn btn-link text-nowrap ml-2 px-0 mr-4"><i class="tlm-icon-question-circle" /></a>
        </template>

        <FormVmSettings ref="vm_settings" :modems="modems" :has-crt="hasCrt" :vm="vm" :sets="sets" @save="save" />
    </TheModal>
</template>

<script>
import store from '@/store'
import TheModal from '@/components/TheModal'
import FormVmSettings from '@/components/FormVmSettings'

import KBLinksService from '@/services/KBLinksService'

export default {
    components: {
        TheModal,
        FormVmSettings
    },

    computed: {
        vm() {
            return this.$store.state.vm.data
        },

        sets() {
            return this.$store.getters['vm/sets']
        },

        modems() {
            return this.$store.state.modems.data
        },

        hasCrt() {
            return this.$store.getters['company/hasCrt']
        }
    },

    methods: {
        async save(data) {
            const success = await this.$store.dispatch('vm/save', data)

            if (success) {
                this.close()
            } else {
                this.$refs.vm_settings.mixinApiErrors(this.$store.state.vm.error)
            }
        },

        close() {
            if (this.vm && this.vm.id) {
                this.$router.push({ 'name': 'vm', params: { id: this.vm.id } })
            } else {
                this.$router.push({ 'name': 'vms' })
            }
        },

        getKBLink(key) {
            return KBLinksService.get(key)
        }
    },

    async beforeRouteEnter(to, from, next) {
        const params = { }

        if (to.params.id) {
            params.free_or_vm = to.params.id
        } else {
            params.free = 1
        }

        if (!to.params.id) {
            store.commit('vm/CLEAR')
        }

        await Promise.all([
            store.dispatch('modems/fetchAll', params)
        ])

        next()
    }
}
</script>
